// OWM weather ID to condition text (used if needed externally)
export const owmCodeToCondition = (weatherId) => {
  if (!weatherId) return 'Clear';
  
  const conditions = {
    200: 'Thunderstorm', 201: 'Thunderstorm', 202: 'Thunderstorm',
    210: 'Thunderstorm', 211: 'Thunderstorm', 212: 'Thunderstorm', 221: 'Thunderstorm',
    230: 'Thunderstorm', 231: 'Thunderstorm', 232: 'Thunderstorm',
    300: 'Light Drizzle', 301: 'Drizzle', 302: 'Heavy Drizzle',
    310: 'Light Rain', 311: 'Rain', 312: 'Heavy Rain',
    313: 'Showers', 314: 'Heavy Showers', 321: 'Showers',
    500: 'Light Rain', 501: 'Rain', 502: 'Heavy Rain', 503: 'Heavy Rain', 504: 'Heavy Rain',
    511: 'Freezing Rain',
    520: 'Light Showers', 521: 'Showers', 522: 'Heavy Showers', 531: 'Showers',
    600: 'Light Snow', 601: 'Snow', 602: 'Heavy Snow',
    611: 'Sleet', 612: 'Sleet', 613: 'Sleet',
    615: 'Light Rain', 616: 'Rain',
    620: 'Light Snow Showers', 621: 'Snow Showers', 622: 'Snow Showers',
    701: 'Fog', 711: 'Fog', 721: 'Fog', 731: 'Fog',
    741: 'Fog', 751: 'Fog', 761: 'Fog', 762: 'Fog',
    771: 'Cloudy', 781: 'Thunderstorm',
    800: 'Clear',
    801: 'Mainly Clear',
    802: 'Partly Cloudy',
    803: 'Cloudy',
    804: 'Overcast'
  };
  
  return conditions[weatherId] || 'Clear';
};

// Backward compat: Foreca symbol decoder - now just a passthrough
// OWM data already comes with condition text from apiService.js transform
export const forecaSymbolToCondition = (symbolOrCode) => {
  // If it's a number (OWM weather ID), decode it
  if (typeof symbolOrCode === 'number') {
    return owmCodeToCondition(symbolOrCode);
  }
  // If it's already a condition string, pass it through
  if (typeof symbolOrCode === 'string') {
    return symbolOrCode;
  }
  return 'Clear';
};

// Backward compat: Normalize condition - now just a passthrough
// OWM conditions are already normalized in apiService.js
export const normalizeForecaCondition = (condition) => {
  if (!condition) return 'Unknown';
  return condition;
};

// Convert time to location timezone
export const convertToLocationTime = (timeString, locationTimezone) => {
  if (!timeString) return '--';
  
  try {
    // Handle unix timestamps (number)
    if (typeof timeString === 'number') {
      const date = new Date(timeString * 1000);
      return date.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        hour12: true,
        timeZone: locationTimezone || undefined
      });
    }
    
    // Handle ISO string
    const date = new Date(timeString);
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      hour12: true,
      timeZone: locationTimezone || undefined
    });
  } catch (error) {
    try {
      const date = new Date(timeString);
      return date.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        hour12: true 
      });
    } catch (e) {
      return '--';
    }
  }
};

// Get weather icon based on condition text and time of day
// This is the TEXT-BASED version - works with OWM condition strings directly
export const getWeatherIconFixed = (conditionText, isDay) => {
  if (!conditionText) return isDay === 1 ? '/sunny.png' : '/clear.png';
  
  const normalizedCondition = conditionText.toLowerCase();
  
  // Check for "mostly clear" or "mainly clear" first
  if (normalizedCondition.includes('mostly clear') || normalizedCondition.includes('mainly clear')) {
    return isDay === 1 ? '/msunny.png' : '/clear.png';
  }
  
  // Snow before rain (snow showers contain "shower")
  if (normalizedCondition.includes('snow') || normalizedCondition.includes('sleet')) {
    return '/snow.png';
  }
  
  if (normalizedCondition.includes('rain') || normalizedCondition.includes('drizzle') || normalizedCondition.includes('shower')) {
    if (normalizedCondition.includes('light')) return '/lightrain.png';
    if (normalizedCondition.includes('heavy')) return '/heavyrain.png';
    if (normalizedCondition.includes('freezing')) return '/sleet.png';
    return '/heavyrain.png';
  }
  
  if (normalizedCondition.includes('thunder')) {
    return '/thunderstorm.png';
  }
  
  if (normalizedCondition.includes('fog') || normalizedCondition.includes('mist')) {
    return '/fog.png';
  }
  
  if (normalizedCondition.includes('cloudy') || normalizedCondition.includes('overcast')) {
    if (normalizedCondition.includes('partly')) {
      return isDay === 1 ? '/partlycloudy.png' : '/cloudynight.png';
    }
    return isDay === 1 ? '/cloudy.png' : '/vcloudynight.png';
  }
  
  return isDay === 1 ? '/sunny.png' : '/clear.png';
};
